import { render } from "./OptionsList.vue?vue&type=template&id=0ed13f3d&scoped=true&ts=true"
import script from "./OptionsList.vue?vue&type=script&lang=ts"
export * from "./OptionsList.vue?vue&type=script&lang=ts"

import "./OptionsList.vue?vue&type=style&index=0&id=0ed13f3d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ed13f3d"]])

export default __exports__